import { useBox } from "@react-three/cannon";

const SHELF_WIDTH = 3;
const SHELF_DEPTH = 1;
const SHELF_THICKNESS = 0.06;
const SHELF_SPACING = 0.8;
const DIVIDER_THICKNESS = 0.04;
const SIDE_THICKNESS = 0.06;
const FIRST_SHELF_Y = 0.4;

const SIDE_HEIGHT = FIRST_SHELF_Y + 3 * SHELF_SPACING + SHELF_THICKNESS;
const SIDE_CENTER_Y = SIDE_HEIGHT / 2;

const shelfY = [0, 1, 2, 3].map((i) => FIRST_SHELF_Y + i * SHELF_SPACING);

export default function Bookshelf({ position, rotation }: { position: [number, number, number]; rotation?: [number, number, number] }) {
	// Static physics collider — one box wrapping the whole unit (mass:0 = immovable)
	const totalWidth = SHELF_WIDTH + SIDE_THICKNESS * 2;
	const [colliderRef] = useBox(() => ({
		mass: 0,
		args: [totalWidth, SIDE_HEIGHT, SHELF_DEPTH],
		position: [
			position[0],
			position[1] + SIDE_CENTER_Y,
			position[2],
		],
		rotation: rotation ?? [0, 0, 0],
		type: "Static",
	}));

	return (
		<group position={position} rotation={rotation}>
			{/* Invisible physics body — ref attached to a hidden mesh */}
			<mesh ref={colliderRef} visible={false}>
				<boxGeometry args={[totalWidth, SIDE_HEIGHT, SHELF_DEPTH]} />
			</mesh>
			<mesh position={[-SHELF_WIDTH / 2 - SIDE_THICKNESS / 2, SIDE_CENTER_Y, 0]} castShadow receiveShadow>
				<boxGeometry args={[SIDE_THICKNESS, SIDE_HEIGHT, SHELF_DEPTH]} />
				<meshStandardMaterial color="white" />
			</mesh>
			<mesh position={[SHELF_WIDTH / 2 + SIDE_THICKNESS / 2, SIDE_CENTER_Y, 0]} castShadow receiveShadow>
				<boxGeometry args={[SIDE_THICKNESS, SIDE_HEIGHT, SHELF_DEPTH]} />
				<meshStandardMaterial color="white" />
			</mesh>
			{shelfY.map((y, i) => (
				<group key={i}>
					<mesh position={[0, y, 0]} castShadow receiveShadow>
						<boxGeometry args={[SHELF_WIDTH, SHELF_THICKNESS, SHELF_DEPTH]} />
						<meshStandardMaterial color="white" />
					</mesh>
					<mesh position={[0, y + SHELF_SPACING / 2, 0]} castShadow receiveShadow>
						<boxGeometry args={[DIVIDER_THICKNESS, SHELF_SPACING, SHELF_DEPTH]} />
						<meshStandardMaterial color="white" />
					</mesh>
				</group>
			))}
		</group>
	);
}
